var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "signup full__video noBoxShadow" }, [
    _vm._m(0),
    _vm._m(1),
    _c("div", { staticClass: "signup__form" }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.forgotPasswordForm.success,
              expression: "forgotPasswordForm.success"
            }
          ],
          staticClass: "message success"
        },
        [
          _c("p", [
            _vm._v(
              "An e-mail has been sent to " + _vm._s(_vm.userInfo.identifier)
            )
          ]),
          _c("a", {
            staticClass: "close",
            on: {
              click: function($event) {
                _vm.forgotPasswordForm.success = false
              }
            }
          })
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.forgotPasswordForm.error,
              expression: "forgotPasswordForm.error"
            }
          ],
          staticClass: "message error"
        },
        [
          _c("p", [_vm._v(_vm._s(_vm.forgotPasswordForm.error))]),
          _c("a", {
            staticClass: "close",
            on: {
              click: function($event) {
                _vm.forgotPasswordForm.error = false
              }
            }
          })
        ]
      ),
      _c(
        "form",
        {
          attrs: { name: "forgotPasswordForm" },
          on: {
            submit: function($event) {
              $event.preventDefault()
              _vm.submitForgotPasswordInvoke(_vm.userInfo)
            }
          }
        },
        [
          _c("h1", [_vm._v("Reset your password")]),
          _c("div", { staticClass: "ui-input" }, [
            _c("p", [_vm._v("Username or Email")]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.userInfo.identifier,
                  expression: "userInfo.identifier"
                }
              ],
              attrs: {
                type: "text",
                disabled: _vm.forgotPasswordForm.success,
                placeholder: "Your username or email",
                required: "required"
              },
              domProps: { value: _vm.userInfo.identifier },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.userInfo, "identifier", $event.target.value)
                }
              }
            })
          ]),
          _c(
            "button",
            {
              staticClass: "btn btn--purpleLight",
              class: _vm.emptyUserString,
              attrs: { type: "submit" }
            },
            [_vm._v("Reset your password")]
          ),
          _c(
            "p",
            [
              _c(
                "router-link",
                { staticClass: "link", attrs: { to: "/login/" } },
                [_vm._v("Sign in here")]
              )
            ],
            1
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "fluid__video splash form__video--horizontal" },
      [
        _c("iframe", {
          attrs: {
            "data-src":
              "https://media.flixel.com/cinemagraph/mv7tif44u6c1vm9e30cs",
            allow: "autoplay"
          }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "fluid__video splash form__video--vertical" },
      [
        _c("iframe", {
          attrs: {
            "data-src":
              "https://media.flixel.com/cinemagraph/ab06d2jrwa3ppzhdym0h?hd=true",
            allow: "autoplay"
          }
        }),
        _c("div", { staticClass: "credit" }, [
          _c(
            "a",
            {
              attrs: {
                target: "_blank",
                href: "https://flixel.com/jimmycheung/"
              }
            },
            [_vm._v("Jimmy Cheung")]
          )
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a3f9cca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a3f9cca","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/auth/ForgotPassword.vue
// module id = null
// module chunks = 